import React from 'react';
import { DatePicker } from 'antd';
import FormItem from '../FormItem/FormItem';
import styles from './SelectDateField.module.scss'

const SelectDateField = ({
  form,
  label,
  name,
  decoratorOptions,
  fieldProps = {},
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem label={label}>
      {getFieldDecorator(
        name,
        decoratorOptions
      )(
        <DatePicker
          format="DD.MM.YYYY"
          showToday={false}
          style={{ width: '100%' }}
          dropdownClassName={styles.dropdown}
          placeholder="Выберите дату"
          {...fieldProps}
        />
      )}
    </FormItem>
  );
};

export default SelectDateField;
